import { useState } from 'react';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Tab, Tabs } from '@optimus-web/core';
import { LocalizedPageTitle, OptimusProvider, PortfolioLayout, PortfolioLayoutHeader } from '@mews-commander/ui';
import { WithGuideLink } from '@mews-commander/types';
import { CentralRateGroupsTable } from './CentralRateGroupsTable';
import { RateGroupsTable } from './RateGroupsTable';
import { RATE_GROUPS_TABS } from './types';
import { RateGroupSidePanelContextProvider } from './sidePanelTabs/RateGroupSidePanelContext';

export const RateGroupsWrapper = ({ guideLink }: WithGuideLink) => {
    const [activeTab, setActiveTab] = useState<RATE_GROUPS_TABS>(RATE_GROUPS_TABS.CENTRAL_RATE_GROUPS);

    return (
        <PortfolioLayout>
            <OptimusProvider density="spacious">
                <PortfolioLayoutHeader
                    title={<LocalizedPageTitle textKey={TextKey.RateGroupPlural} />}
                    guideLink={guideLink}
                />
                <Tabs
                    underline
                    inline
                    onTabClick={(_, value) => setActiveTab(value as RATE_GROUPS_TABS)}
                    activeTabValue={activeTab}
                >
                    <Tab
                        inline
                        id={RATE_GROUPS_TABS.CENTRAL_RATE_GROUPS}
                        value={RATE_GROUPS_TABS.CENTRAL_RATE_GROUPS}
                        label={<LocalizedText textKey={TextKey.CentralRateGroups} />}
                    />
                    <Tab
                        inline
                        id={RATE_GROUPS_TABS.LOCAL_RATE_GROUPS}
                        value={RATE_GROUPS_TABS.LOCAL_RATE_GROUPS}
                        label={<LocalizedText textKey={TextKey.LocalRateGroups} />}
                    />
                </Tabs>

                <RateGroupSidePanelContextProvider>
                    {activeTab === RATE_GROUPS_TABS.CENTRAL_RATE_GROUPS ? (
                        <CentralRateGroupsTable />
                    ) : (
                        <RateGroupsTable />
                    )}
                </RateGroupSidePanelContextProvider>
            </OptimusProvider>
        </PortfolioLayout>
    );
};
